var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessLoanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_9095_22460)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#A099F3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9711 12.9999C17.6409 12.9999 17.3727 12.7166 17.3727 12.3679V11.2631H14.98V12.3688C14.98 12.7175 14.7127 13.0008 14.3816 13.0008C14.0515 13.0008 13.7833 12.7175 13.7833 12.3688V11.2631C13.7833 10.5666 14.3197 10 14.9791 10H17.3718C18.0312 10 18.5677 10.5666 18.5677 11.2631V12.3688C18.5695 12.7175 18.3021 12.9999 17.9711 12.9999Z",
    fill: "#EFEDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9501 16.4731H16.4049C17.1038 16.4731 17.6726 17.0738 17.6726 17.812C17.6726 18.4762 17.2195 19.022 16.6256 19.1338V19.6312C16.6256 19.8927 16.4247 20.105 16.177 20.105C15.9294 20.105 15.7285 19.8927 15.7285 19.6312V19.1575H15.1301C14.8825 19.1575 14.6815 18.9452 14.6815 18.6837C14.6815 18.4222 14.8825 18.2099 15.1301 18.2099H16.404C16.6086 18.2099 16.7745 18.0337 16.7745 17.8186C16.7745 17.5969 16.6077 17.4206 16.404 17.4206H15.9492C15.2503 17.4206 14.6815 16.8199 14.6815 16.0818C14.6815 15.4175 15.1346 14.8718 15.7285 14.76V14.2625C15.7285 14.001 15.9294 13.7887 16.177 13.7887C16.4247 13.7887 16.6256 14.001 16.6256 14.2625V14.7363H17.224C17.4716 14.7363 17.6726 14.9485 17.6726 15.21C17.6726 15.4716 17.4716 15.6838 17.224 15.6838H15.9501C15.7455 15.6838 15.5796 15.86 15.5796 16.0751C15.5787 16.2969 15.7455 16.4731 15.9501 16.4731ZM10.6444 11.8937C9.73744 11.8937 9 12.6725 9 13.6305V20.2632C9 21.2212 9.73744 22 10.6444 22H21.7087C22.6166 22 23.3541 21.2212 23.3541 20.2632V13.6305C23.3541 12.6725 22.6166 11.8937 21.7096 11.8937H10.6444Z",
    fill: "#EFEDFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9095_22460",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9095_22460"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessLoanIcon);
export default __webpack_public_path__ + "static/media/business-loan-icon.a578e4b572da47a0f31d6d9c14bfb5c1.svg";
export { ForwardRef as ReactComponent };